import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { LocationGridDataService } from 'common/services/data-services/admin/location/location-grid-data.service';
import { LocationModel } from 'common/models/page-models/Location/location-data-model';
import { LocationGridMetaModel } from 'common/models/page-models/Location/location-grid-meta-model';
import { LocationListingModel } from 'common/models/page-models/Location/location-grid-model';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { LocationMetaModel } from 'common/models/page-models/Location/location-form-meta-model';





 
@Injectable({
    providedIn: 'root'
})
export class LocationGridWidgetService extends GridWidgetService<LocationModel, LocationListingModel> {
    constructor(protected override ds: LocationGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new LocationGridMetaModel().getMetaModel();
        return meta;
    }

    
    // override prepareMetaModel(dataModel: DataModel, metaModel: LocationMetaModel, routeData: WidgetModel): Promise<LocationMetaModel> {
    //     return new Promise<LocationMetaModel>((resolve, reject) => {
    //         metaModel.pageTitle = dataModel.id !== 0 ?  'Update Location' : 'Add Location';
    //         resolve(metaModel);
    //     });
    // }
}